import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { feedbackForm } from "./feedbacks.models";
import { SubSink } from "subsink";
import { WebAppFeedbackService } from "./feedbacks.service";
import { Router } from "@angular/router";
import { IdentityService } from "../../shared/services/authentication/identity.service";

@Component({
	selector: 'webapp-feedbacks-component',
	templateUrl: './feedbacks.component.html',
	styleUrl: './feedbacks.component.scss'
})

export class WebAppFeedbackComponent implements OnInit
{
	// subsink
	private subs = new SubSink();

	// I/O
	@Input('timeslotId') timeslotId: string;
	@Input('feedbackId') feedbackId: string;

	// variables
	public isSending: boolean = false;
	public selectedRating = 0;
	public stars = [
		{
			id: 1,
			icon: 'star',
			class: 'star-gray star-hover star'
		},
		{
			id: 2,
			icon: 'star',
			class: 'star-gray star-hover star'
		},
		{
			id: 3,
			icon: 'star',
			class: 'star-gray star-hover star'
		},
		{
			id: 4,
			icon: 'star',
			class: 'star-gray star-hover star'
		},
		{
			id: 5,
			icon: 'star',
			class: 'star-gray star-hover star'
		}
	];

	// form
	public form = this.fb.group<feedbackForm>({
		id: this.fb.control(null),
		timeslotId: this.fb.control(null),
		vote: this.fb.control(null, Validators.required),
		note: this.fb.control(null)
	});

	// constructor
	constructor(
		private fb: FormBuilder,
		private feedbackService: WebAppFeedbackService,
		private router: Router
	) { }

	// on init
	ngOnInit()
	{
		if (this.feedbackId)
		{
			// get single
			this.getSingle();
		} else
		{
			this.form.patchValue({ timeslotId: this.timeslotId });
		}
	}

	onSubmit()
	{
		this.insertUpdate();
	}

	// get single
	getSingle()
	{
		this.subs.sink = this.feedbackService.single(this.feedbackId).subscribe(result =>
		{
			// patch form
			this.form.patchValue(result);

			this.selectedRating = result.vote;
			this.stars.filter((star) =>
			{
				if (star.id <= this.selectedRating)
				{
					star.class = 'star-gold star';
				} else
				{
					star.class = 'star-grey star';
				}
				return star;
			})
		});
	}

	// insert/update
	insertUpdate()
	{
		this.isSending = true;
		// form value
		const formValue = this.form.value;

		this.subs.sink = this.feedbackService.insert(formValue).subscribe({
			next: (result) =>
			{
				this.router.navigate(['/app/customer/dashboard']);
				this.isSending = false;
			},
			error: (error) =>
			{
				console.log(error);
			}
		});
	}

	// select rating
	selectStar(value): void
	{
		this.stars.filter((star) =>
		{
			if (star.id <= value)
			{
				star.class = 'star-gold star';
			} else
			{
				star.class = 'star-grey star';
			}
			return star;
		});

		this.selectedRating = value;
		this.form.patchValue({ vote: this.selectedRating });
	}

}